import { useGlobalContext } from "context/GlobalContext";
import { createContext, useContext, useEffect, useState } from "react";
import { message } from "constants/responses/message";
import { TASK_LIST_TYPE, taskOperationsList } from "./constants/task.constants";
import { fetchTasksApi } from "API/apis/task/getTasks";
import { useSearchParams } from "react-router-dom";
import { filterStringToObject } from "utils/functions/reactTableFilterConverter";
const initialValue = {
  createdByMe: [
    {
      id: 0,
      taskDetails: "",
      docDetails: "",
      docId: 0,
      subDocId: 0,
      deadline: null,
      acceptanceStatus: "",
      taskBy: { name: "", dept: "", subDept: "", userId: "" },
      taskByOn: null,
      taskTo: { name: "", dept: "", subDept: "", userId: "" },
      docType: 0,
      taskToOn: null,
      doneOn: null,
      doneStatus: "",
      acceptanceComment: "",
      acceptanceOn: null,
    },
  ],
  assignedToMePending: [
    {
      id: 0,
      taskDetails: "",
      docDetails: "",
      docId: 0,
      subDocId: 0,
      deadline: null,
      acceptanceStatus: "",
      taskBy: { name: "", dept: "", subDept: "", userId: "" },
      taskByOn: null,
      taskTo: { name: "", dept: "", subDept: "", userId: "" },
      docType: 0,
      taskToOn: null,
      doneOn: null,
      doneStatus: "",
      acceptanceComment: "",
      acceptanceOn: null,
    },
  ],
  assignedToMeAccepted: [
    {
      id: 0,
      taskDetails: "",
      docDetails: "",
      docId: 0,
      subDocId: 0,
      deadline: null,
      acceptanceStatus: "",
      taskBy: { name: "", dept: "", subDept: "", userId: "" },
      taskByOn: null,
      taskTo: { name: "", dept: "", subDept: "", userId: "" },
      docType: 0,
      taskToOn: null,
      doneOn: null,
      doneStatus: "",
      acceptanceComment: "",
      acceptanceOn: null,
    },
  ],
  rejected: [
    {
      id: 0,
      taskDetails: "",
      docDetails: "",
      docId: 0,
      subDocId: 0,
      deadline: null,
      acceptanceStatus: "",
      taskBy: { name: "", dept: "", subDept: "", userId: "" },
      taskByOn: null,
      taskTo: { name: "", dept: "", subDept: "", userId: "" },
      docType: 0,
      taskToOn: null,
      doneOn: null,
      doneStatus: "",
      acceptanceComment: "",
      acceptanceOn: null,
    },
  ],
  acknowledged: [
    {
      id: 0,
      taskDetails: "",
      docDetails: "",
      docId: 0,
      subDocId: 0,
      deadline: null,
      acceptanceStatus: "",
      taskBy: { name: "", dept: "", subDept: "", userId: "" },
      taskByOn: null,
      taskTo: { name: "", dept: "", subDept: "", userId: "" },
      docType: 0,
      taskToOn: null,
      doneOn: null,
      doneStatus: "",
      acceptanceComment: "",
      acceptanceOn: null,
    },
  ],
};
const initialUpdateValue = {
  id: 0,
  taskDetails: "",
  deadline: null,
  companyId: 0,
  taskTo: { name: "", dept: "", subDept: "", userId: "" },
};

const TaskContext = createContext({
  currentOperationPage: "",
  setCurrentOperationPage: () => {},
  list: {
    createdByMe: [],
    assignedToMePending: [],
    assignedToMeAccepted: [],
    rejected: [],
    acknowledged: [],
  },
  setList: () => {},
  reloadRequired: false,
  setReloadRequired: () => {},
  currentSelectedRowForUpdate: initialUpdateValue,
  setCurrentSelectedRowForUpdate: () => [],
});

export const TaskProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const paramsToObject = Object.fromEntries(searchParams.entries());

  const [list, setList] = useState(initialValue);
  const [reloadRequired, setReloadRequired] = useState(false);
  const [currentSelectedRowForUpdate, setCurrentSelectedRowForUpdate] =
    useState(initialUpdateValue);
  const [currentOperationPage, setCurrentOperationPage] = useState(
    taskOperationsList.listTask
  );
  const { setIsInitializing, setError, setIsLoading } = useGlobalContext();

  const [allParams, setAllParams] = useState({
    ...paramsToObject,
    filters: filterStringToObject(paramsToObject.filters) || "",
    type: TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key,
  });

  useEffect(() => {
    setAllParams({
      ...paramsToObject,
      filters: filterStringToObject(paramsToObject.filters),
      type: paramsToObject.type || TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key,
    });
  }, [searchParams]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsInitializing(true);
        const { data, status } = await fetchTasksApi(allParams);
        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }
        setList(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsInitializing(false);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [reloadRequired, allParams]);

  return (
    <TaskContext.Provider
      value={{
        currentOperationPage,
        setCurrentOperationPage,
        list,
        setList,
        reloadRequired,
        setReloadRequired,
        currentSelectedRowForUpdate,
        setCurrentSelectedRowForUpdate,
      }}
    >
      <>{children}</>
    </TaskContext.Provider>
  );
};

export const useTaskContext = () => {
  const context = useContext(TaskContext);
  if (!context) {
    throw new Error("useTaskContext must be used within a TaskProvider");
  }
  return context;
};
